;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('SidebarService', SidebarService)

  SidebarService.$inject = ['DisplayService']

  /**
   * Constructor
   */
  function SidebarService (DisplayService) {
    var self = this
    /**
     *
     */
    var visible = false
    //
    _.extend(self, {
      // Public Attributes
      visible: visible,

      // Public Methods
      toggle: toggle
    })

    function toggle () {
      self.visible = !self.visible // REACTIVATE IF YOU WANT TO TOGGLE
      DisplayService.overlayVisible = !DisplayService.overlayVisible
    }
  }
})(window.angular, window._)
